import useWindowDimensions from "hooks/useWindowDimension";
import { PopOverMenuItem } from "./PopOverMenuItem";
import { IGroup, IItem } from "./PopOverMenu";

import "./style/PopOverMenuList.scss";

export const PopOverMenuList = ({ groupName, groupMobileName, items }: IGroup) => {
  const isDesktop = useWindowDimensions();

  return (
    <div className="PopOverMenuList">
      {groupName && isDesktop && <h4 className="PopOverMenuList-Title">{groupName}</h4>}
      {groupMobileName && !isDesktop && <h4 className="PopOverMenuList-Title">{groupMobileName}</h4>}
      <div className="PopOverMenuList-List">
        {items.map(({ icon, onClick, title }: IItem, index: number) => (
          <PopOverMenuItem icon={icon} title={title} onClick={onClick} key={index} />
        ))}
      </div>
    </div>
  );
};
